import { unitMapping } from 'lib/style';

type Props = { size?: keyof typeof unitMapping };
export const LineupSet = ({ size = 2 }: Props) => {
  return (
    <svg
      style={{
        width: unitMapping[size],
        height: unitMapping[size],
      }}
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1358_15091)">
        <path
          id="Vector"
          d="M2.8996 23.1229V12.562L6.8997 13.606V23.0797H8.49974V11.6485L13.3086 12.9581V23.0797H14.8999V8.0002L26.9002 9.40531V23.0797H28.4915V12.7881L32.5003 11.6485C32.5003 11.6485 32.5003 13.0544 32.5003 13.9552C32.5003 17.5185 32.5003 23.0797 32.5003 23.0797L34.1197 23.099V13.6703L38.0563 12.5813V23.1716L41.3005 23.099L20.9 29.6007V29.575L0.499538 23.0732L2.8996 23.1229Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1358_15091">
          <rect
            width="40.001"
            height="40.001"
            fill="white"
            transform="translate(0.499512)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
